// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-watch[data-v-72fe3406]{position:relative}.phone-watch-btn[data-v-72fe3406]{display:flex;align-items:center;vertical-align:middle}.phone-watch-btn .icon[data-v-72fe3406]{font-size:24px;margin-right:2px}.phone-watch-popup-wrap[data-v-72fe3406]{position:absolute;z-index:100;left:-18px;top:30px;padding-top:10px}", ""]);
// Exports
module.exports = exports;
